module.exports = __webpack_public_path__ + "img/sweat-preto.8b7fb1cf.jpg";